import { partitions } from "@/mocks/hotTopics";

const zoneDot = [
  "bg-primary-500",
  "bg-accent-500",
  "bg-secondary-500",
  "bg-foreground-500",
];

export default function PartitionIndex() {
  return (
    <section id="forums" className="bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
              分区合集 · 索引
            </p>
            <h4 className="flex items-center gap-3 font-serif text-2xl font-black text-foreground-950 md:text-3xl">
              <a href="#forums" className="flex items-center gap-3">
                按哪个分区进
              </a>
            </h4>
          </div>
          <p className="max-w-xs text-sm leading-relaxed text-foreground-500">
            把同一类讨论归拢成合集，方便你快速索引到感兴趣的舆论场。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {partitions.map((p, i) => (
            <a
              key={p.name}
              href="#rank"
              className="group-card flex flex-col rounded-xl border border-background-200 bg-background-100/50 p-5"
            >
              <div className="flex items-start justify-between">
                <span
                  className={`flex h-10 w-10 items-center justify-center rounded-lg text-base text-background-50 ${zoneDot[i % zoneDot.length]}`}
                >
                  <i className={i % 2 === 0 ? "ri-question-answer-line" : "ri-chat-smile-2-line"} />
                </span>
                <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-900">
                  {p.hot} 个正热
                </span>
              </div>

              <div className="mt-4 flex items-baseline gap-2">
                <h5 className="font-serif text-lg font-black text-foreground-950">{p.name}</h5>
                <span className="text-[10px] tracking-wider text-foreground-400">{p.en}</span>
              </div>
              <p className="mt-1 text-xs text-foreground-500">{p.desc}</p>

              <div className="mt-3 flex flex-wrap items-center gap-2">
                {p.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-md border border-background-300 bg-background-50 px-2 py-0.5 text-[11px] text-foreground-600"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                <span className="text-xs text-foreground-500">
                  收录 <b className="text-foreground-800">{p.count.toLocaleString()}</b> 条讨论
                </span>
                <span className="flex items-center text-xs font-medium text-primary-600">
                  进分区
                  <i className="ri-arrow-right-s-line text-base" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}